import { TargetOptions } from '@/types/Target';
import { State } from './state';
import { SingleTargetResponse } from './types';
import { formatDataValue } from '@/helpers/format';
import { HighchartsSeries } from '@/types/Global';
import { GetterTree } from 'vuex';
import { RootState } from '@/store';

export type Getters = {
  getTargets(state: State): TargetOptions[];
  isLoading(state: State): boolean;
};

const getChartSeries = (target: SingleTargetResponse): HighchartsSeries[] => {
  const percentage = target.percentage.dataValue as number;
  const barValue = percentage > 1 ? 1 : percentage < 0 ? 0 : percentage;
  const remainingValue = percentage > 1 ? 0 : 1 - barValue;

  const series: HighchartsSeries[] = [
    {
      name: formatDataValue(target.targetType) as string,
      data: [barValue],
      className: 'fill-primary',
    },
    {
      name: 'null',
      data: [remainingValue],
      className: 'fill-light-grey',
    },
  ];

  return series;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getTargets: state => {
    const formatOptions = { keepZeroAsZero: true };

    return state.targets.map(target => ({
      type: formatDataValue(target.targetType) as string,
      data: {
        achieved: formatDataValue(target.achieved, formatOptions) as string,
        target: target.target
          ? (formatDataValue(target.target, formatOptions) as string)
          : null,
        percentage: target.percentage
          ? (formatDataValue(target.percentage, formatOptions) as string)
          : null,
      },
      chartSeries: getChartSeries(target),
    }));
  },
  isLoading: state => {
    return state.loading;
  },
};
